module.exports = __webpack_public_path__ + "media/images/icon-check-white-4956c01c65af0fddb9c1860c59d681d3.svg";